import generalTransformer from '@/services/general/filters/serverTableDataTransformer';

export default function transformerSociete(serverTableData) {
  if (!serverTableData.orderBy) {
    serverTableData.ascending = 0;
    serverTableData.orderBy = 'codeSociete';
  }
  return generalTransformer(serverTableData);
}
